import { render, staticRenderFns } from "./ViewTenorVideos.vue?vue&type=template&id=0c46aaca&"
import script from "./ViewTenorVideos.vue?vue&type=script&lang=js&"
export * from "./ViewTenorVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports